import api from '@services/api'

export default {
  list(axios, params, query, config) {
    return api.get(axios, '/manager/firmwares', params, query, config)
  },

  get(axios, params, query, config) {
    return api.get(axios, '/manager/firmwares/:id', params, query, config)
  },

  create(axios, params, payload, config) {
    return api.post(axios, '/manager/firmwares', params, payload, config)
  },

  update(axios, params, payload, config) {
    return api.update(axios, '/manager/firmwares/:id', params, payload, config)
  },

  destroy(axios, params, config) {
    return api.delete(axios, '/manager/firmwares/:id', params, config)
  },

  panel(axios, params, query, config) {
    return api.get(axios, '/manager/firmwares/:id/panel', params, query, config)
  },

  transition(axios, params, payload, config) {
    return api.update(
      axios,
      '/manager/firmwares/:id/transition/:transition',
      params,
      payload,
      config
    )
  },

  attachment(axios, params, payload, config) {
    return api.update(
      axios,
      '/manager/firmwares/:id/attachment/:attachment',
      params,
      payload,
      config
    )
  },
}
